import { ContactView } from 'src/sections/contact/contact-view';

export default function ContactPage() {
  return <ContactView />;
}
